import React from 'react';
import styled, { css } from 'styled-components';
import { CommonText } from '../../bumpViews/commonText';
const BottomBtnWrapper = styled.div `
  ${({ highlighted, active }) => {
    if (highlighted) {
        return css `
        background: #fff;
        color: #fb2f2f;
        border: 1px solid #fb2f2f;
      `;
    }
    if (active) {
        return css `
        background: #FB2F2F;
        color: #fff;
      `;
    }
    return css `
      background: #dfdfdf;
    `;
}}
  padding: 12px;
  border-radius: 4px;
  margin-right: 8px;
  cursor: pointer;
`;
export const BottomControlBtn = ({ onClick, highlighted, cancelBtn, active, children, style }) => {
    const btnColorMapper = () => {
        if (highlighted) {
            return '#FB2F2F';
        }
        if (cancelBtn) {
            return '#4B4F5E';
        }
        if (active) {
            return '#FFF';
        }
        return '#6B7270';
    };
    return (React.createElement(BottomBtnWrapper, { highlighted: highlighted, onClick: onClick, active: active, style: style },
        React.createElement(CommonText, { size: "semiMedium", weight: 600, color: btnColorMapper(), lineHeight: "16px" }, children)));
};
//# sourceMappingURL=index.js.map